import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAME } from './constants';
import { AppContainerState, Page } from './app';

const initialState: AppContainerState = {
  searchQuery: { allEvents: '', results: '', summary: '' },
};

export const slice = createSlice({
  name: SLICE_NAME,
  initialState,

  reducers: {
    setSearchQuery: (state, action: PayloadAction<[Page, string]>) => {
      const [key, value] = action.payload;
      state.searchQuery[key] = value;
    },
  },
});

export const { setSearchQuery } = slice.actions;

export default slice.reducer;
